import { render, staticRenderFns } from "./SafetyConfirmOtherUsersResponseRateModal.vue?vue&type=template&id=4deb854f&lang=pug"
import script from "./SafetyConfirmOtherUsersResponseRateModal.vue?vue&type=script&lang=ts"
export * from "./SafetyConfirmOtherUsersResponseRateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports